<template>
  <div class="live-win">
    <img :src="item.gameIcon" class="game-icon">
    <div class="info">
      <div class="username">{{ item.userLabel }}</div>
      <div class="win">
        <img src="/img/coins/gold_coin.svg">
        <span class="amount hidden">{{ numberFormatter.formatNumber(props.item.win.amount) }}</span>
        <span class="amount">{{ numberFormatter.formatNumber(displayValue)}}</span>
        <span class="multiplier">x{{ numberFormatter.formatNumber(item.multiplier, 0)}}</span>
      </div>
      <div class="duration">{{ durationLabel }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {numberFormatter} from "@/service/NumberFormatter";
import LiveWinDTO from "@/models/LiveWinDTO";
import {nowState, userTimeZone} from "@/service/DateHelper";
import {computed, onMounted, ref} from "vue";
import moment from "moment-timezone";
import {$t} from "@/i18n";

const props = defineProps<{
  item: LiveWinDTO
}>()

const displayValue = ref(props.item.win.amount);

const durationLabel = computed(() => {
  const m = (moment(props.item.createdAt)).utcOffset(0).tz(userTimeZone())

  const seconds = moment(nowState.now).diff(m, "seconds");
  if (seconds < 60) return $t('time_ago.seconds', {seconds});

  const minutes = moment(nowState.now).diff(m, "minutes");
  if (minutes < 60) return $t('time_ago.minutes', {minutes});

  const hours = moment(nowState.now).diff(m, "hours");
  if (hours < 24) return $t('time_ago.hours', {hours});

  const days = moment(nowState.now).diff(m, "days");
  return $t('time_ago.days', {days});
})

const animateValue = (from: number, to: number, duration = 800) => {
  const start = performance.now();

  function frame(now: number) {
    const progress = Math.min((now - start) / duration, 1);
    const value = from + (to - from) * progress;

    displayValue.value = Math.floor(value).toString()
    if (progress < 1) {
      requestAnimationFrame(frame);
    }
  }
  requestAnimationFrame(frame);
}

onMounted(() => {
  animateValue(0, Number.parseFloat(props.item.win.amount));
})
</script>